// extracted by mini-css-extract-plugin
export default {"page":"ErrorPage_page__EgmC8","card":"ErrorPage_card__WtOK9","title":"ErrorPage_title__j15wW","message":"ErrorPage_message__RT15H","button":"ErrorPage_button__USGJY"};